<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="grid-column ai-c jc-s gap-10">
        <button
          type="button"
          class="ac-close-button"
          @click="toggleActionModal(false)"
        >
          <img
            src="@shared/assets/img/general/x-black.png"
            alt="x"
            class="ac-close"
          >
        </button>
        <div class="sac__font-18 semi-bold">
          Delete Note
        </div>
      </div>
    </div>
    <div class="ac-body-container">
      <div class="sac__font-14 med">
        Are you sure you want to delete this note?
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="sac__button bg-transparent"
        @click="toggleActionModal(false)"
      >
        No
      </button>
      <button
        class="sac__button bg-primary margin-left-16"
        :disabled="loading"
        @click="handleDelete"
      >
        <img
          v-if="loading"
          class="ac-processing"
          src="@shared/assets/img/general/loading-white.svg"
          alt="processing"
        >
        <span v-else>Yes</span>
      </button>
    </div>
  </div>
</template>

<script>
import serviceMixin from '@shared/mixins/serviceMixin';

export default {
  name: 'DeleteNote',
  mixins: [serviceMixin],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async handleDelete() {
      this.loading = true;
      if (this.selectedNote.logId) {
        await this.$store.dispatch('deleteNote', this.selectedNote);
      }
      this.loading = false;
      this.toggleActionModal(false);
    },
  },
};
</script>
